import * as R from "ramda";
import { call, reducer } from "../../helpers/api/meta";
import { additionalData } from "../../helpers/api/api";

export const GET_ADDITIONAL_DASHBOARD = "GET_ADDITIONAL_DASHBOARD";

export const callGetAdditionalDashboard = (inputs) => {
  const meta = {
    endpoint: (params) => additionalData(params),
    inputs,
    action: GET_ADDITIONAL_DASHBOARD,
    messages: {
      id: "additionalDashBoard",
      failure: "Could not get  dashboard data.",
    },
  };
  return call(meta);
};

const initialState = {
  loading: false,
  result: [],
};

const messages = {
  loadFailed: "Could not load Classroom.",
};

const saveAdditionalDashboard = (state, action) => {
  return R.assoc("result", action.result, state);
};

export default reducer(
  initialState,
  GET_ADDITIONAL_DASHBOARD,
  saveAdditionalDashboard,
  messages.loadFailed
);
